import React, { FC } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownItem } from 'components/DropdownItem/DropdownItem';
import { useServiceType } from 'hooks/context/serviceType';
import { ServiceTypeLabel } from 'hooks/context/serviceType/models';
import { SERVICE_TYPES_TEST_IDS } from './ServicesDropdown.const';
import styles from './ServicesDropdown.module.scss';

type ServicesDropdownProps = {
  currentServiceType?: string;
  handleSelect: (selectedService: ServiceTypeLabel) => void;
  readonly?: boolean;
};

export const ServicesDropdown: FC<ServicesDropdownProps> = ({ currentServiceType, handleSelect, readonly = false }) => {
  const { t } = useTranslation();
  const { serviceTypes } = useServiceType();

  return (
    <Dropdown
      readonly={readonly}
      label={t('cart.orderType')}
      defaultValue={currentServiceType ? t(`serviceTypes.${currentServiceType.toLowerCase()}`) : ''}
      dataTestId={SERVICE_TYPES_TEST_IDS.orderTypeDropDownBtn}
      selectClassName={styles.orderTypeDropdownSelect}
    >
      {serviceTypes.map((item, index) => (
        <DropdownItem
          className={styles.item}
          key={index}
          value={item.label}
          onClick={() => handleSelect(item)}
          data-testid={item.name.toLowerCase()}
        >
          <div className={clsx(styles.name)}>{item.label}</div>
        </DropdownItem>
      ))}
    </Dropdown>
  );
};
